import { render } from "./BaseCard.vue?vue&type=template&id=52d67db3&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=52d67db3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d67db3"]])

export default __exports__